module.exports = __webpack_public_path__ + "static/img/zhinengdaozhen.fa19ff08.png";